import { render, staticRenderFns } from "./ClsTable.vue?vue&type=template&id=3aff369d&scoped=true"
import script from "./ClsTable.vue?vue&type=script&lang=js"
export * from "./ClsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aff369d",
  null
  
)

export default component.exports